/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The information about the current build of the application
 */
export interface BuildInformation { 
    /**
     * The user ID of the user that performed the build
     */
    buildUser: string;
    /**
     * The date/time when the build was performed
     */
    buildDate: string;
    /**
     * The version number (from Maven POM) of the current build
     */
    buildNumber: string;
}
